// Color palette based on provided screenshot
export const COLORS = {
  darkTeal: '#184B54', // left stripe
  red: '#F44F3B',     // middle stripe
  offWhite: '#F8F4E3',// right stripe
  white: '#FFFFFF',   // background
  green: '#5FC39B',  // accent green from stripes
}; 